import { render } from "./VgtGlobalSearch.vue?vue&type=template&id=76b44c4b"
import script from "./VgtGlobalSearch.vue?vue&type=script&lang=js"
export * from "./VgtGlobalSearch.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__